<template>
  <div class="after-sales">
    <div class="after-sales-content">
      <div class="after-sales-title">
      <div class="medium">{{message.username}}</div>
      <div>{{message.createAt}}</div>
    </div>
    <div class="after-sales-name" v-if="status===6">
      The Retailer ({{message.username}}) created a refund request on {{message.createAt}}
    </div>
    <div class="after-sales-name" v-if="status===80">
      Modified after-sales application
    </div>
    <div  class="after-sales-reason">
      <div>Refund type:  Refund</div>
      <div>Refund amount: ${{message.refundTotalAmount}}</div>
      <div>Reason for refund: {{message.reason}}</div>
      <div>Description of refund: {{message.submitFeedback}}</div>
    </div>
    </div>
  </div>
</template>

<script>
// 发起，修改售后单
export default {
  name: 'afterSales',
  props: {
    message: {
      default: () => { return {} },
      type: Object
    },
    status: {
      default: 6,
      type: Number
    }
  }

}
</script>

<style lang="less" scoped>
.after-sales{
  padding: 20px;
}
.after-sales-content{
  padding-bottom: 30px;
  border-bottom: 1px solid #e1e1e1;
  line-height: 32px;
}
.after-sales-title{
  display: flex;
  justify-content: space-between;
}
.medium{
  font-family: Satoshi-medium;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/history-list/after-sales.vue